export default __webpack_public_path__ + "f6003ff1058b2930c534324841d676fe.png";